module.exports = __webpack_public_path__ + "static/media/pages3.a9e02de2.JPG";